import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import { NovaActivityService } from '../services/nova-activity.service';
import { AiAssistantUiService } from '../services/ai-assistant-ui.service';
import { NovaWorkItem } from '../ai-chatbot/nova-activity';

type WorkFilter = 'all' | 'active' | 'attention' | 'finished';
@Component({
  selector: 'app-nova-work',
  imports: [CommonModule],
  templateUrl: './nova-work.component.html',
  styleUrl: './nova-work.component.scss',
})
export class NovaWorkComponent {
  readonly page = input(false);
  readonly openingConversationId = input<string | null>(null);
  readonly activity = inject(NovaActivityService);
  readonly ui = inject(AiAssistantUiService);
  readonly filter = signal<WorkFilter>('all');
  readonly attention = computed(() =>
    this.activity.completed().filter((item) => item.status === 'attention')
  );
  readonly finished = computed(() =>
    this.activity.completed().filter((item) => item.status !== 'attention')
  );
  readonly filters = computed(() => [
    {
      key: 'all' as const,
      label: 'All tasks',
      count: this.activity.items().length,
    },
    {
      key: 'active' as const,
      label: 'Working',
      count: this.activity.active().length,
    },
    {
      key: 'attention' as const,
      label: 'Needs attention',
      count: this.attention().length,
    },
    {
      key: 'finished' as const,
      label: 'Finished',
      count: this.finished().length,
    },
  ]);
  readonly groups = computed(() =>
    [
      { key: 'active', title: 'Working on it', items: this.activity.active() },
      {
        key: 'attention',
        title: 'Needs your attention',
        items: this.attention(),
      },
      { key: 'finished', title: 'Ready to pick up', items: this.finished() },
    ].filter(
      (group) =>
        group.items.length &&
        (this.filter() === 'all' || this.filter() === group.key)
    )
  );

  statusLabel(item: NovaWorkItem): string {
    return item.status === 'cancelled'
      ? 'Cancelled'
      : item.status === 'attention'
      ? 'Needs attention'
      : item.status === 'ready'
      ? 'Ready'
      : item.status === 'waiting'
      ? 'Queued'
      : 'Working';
  }
  actionLabel(item: NovaWorkItem): string {
    return item.status === 'ready'
      ? 'View result'
      : item.status === 'cancelled'
      ? 'View conversation'
      : item.status === 'attention'
      ? 'See next step'
      : 'Follow progress';
  }
  icon(item: NovaWorkItem): string {
    return item.status === 'ready'
      ? 'pi pi-check'
      : item.status === 'cancelled'
      ? 'pi pi-minus'
      : item.status === 'attention'
      ? 'pi pi-exclamation-circle'
      : 'pi pi-sparkles';
  }
}
